import styled from "@emotion/styled";
// @ts-expect-error
import units from "design-units";

export const ApprovedMarker = styled.div`
  border: 2px solid;
  border-radius: 3em;
  display: inline-block;
  font-weight: 600;
  font-size: 13px;
  padding: 5px 15px;
  ${units({
    color: "treeGreen",
    borderColor: "treeGreen",
  })};
`;

export const DraftMarker = styled.div`
  border: 2px solid;
  border-radius: 3em;
  display: inline-block;
  font-weight: 600;
  font-size: 13px;
  padding: 5px 15px;
  ${units({
    color: "grey",
    borderColor: "grey",
  })};
`;
